'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M15.62 7.544H12.81c-.124 0-.224.1-.224.224v5.703c0 .124.1.225.224.225h5.765a.224.224 0 0 0 .224-.225v-2.746c0-.124-.1-.224-.224-.224h-2.733V7.768c0-.124-.1-.224-.224-.224Zm-.45.673v2.957h2.957v1.849H13.26V8.217h1.91Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.733 3c.185 0 .336.151.336.337v2.48h14.123c.185 0 .336.15.336.336v14.511a.337.337 0 0 1-.336.336H5.732a2.734 2.734 0 0 1-2.73-2.676H3V5.732A2.736 2.736 0 0 1 5.733 3Zm14.122 3.49H6.069v9.382a.337.337 0 0 1-.336.337c-1.136 0-2.06.923-2.06 2.059 0 1.135.924 2.059 2.06 2.059h14.122V6.49ZM18.8 17.133v.673h-7.205v1.467h-.673V17.47c0-.186.151-.336.336-.336H18.8Zm-9.925-4.22c.186 0 .337.151.337.336v6.024h-.673v-5.687H7.144v-.673h1.73Zm-3.48-9.212a2.062 2.062 0 0 0-1.722 2.031v10.744a2.73 2.73 0 0 1 1.723-.92Zm6.2 3.843v7.205h7.206v.673h-7.542a.337.337 0 0 1-.337-.337v-7.54h.674Zm-2.383 0v3.322a.337.337 0 0 1-.337.337H7.143v-.673h1.395V7.543h.674Z",
    fill: "#3F3E4B"
  })));
});
var FwSet0Corner = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Corner = FwSet0Corner;